import { gql } from '@/utilities/gql';

export const NARRATIVE_COMPANY_PRIMARY_VALUATION_FRAGMENT = gql(`
  fragment NarrativeCompanyPrimaryValuationFields on Company @_unmask {
    analysisValue {
      lastSharePrice
    }
    myValuation {
      fairValue
      narrative {
        updatedAt
        valuations {
          fairValue
          createdAt
        }
      }
    }
    defaultNarrative {
      title
      updatedAt
      valuation {
        fairValue
      }
      valuations {
        fairValue
        createdAt
      }
    }
  }
`);
